import React from 'react';

function SaveValidationModal({ show, errors, warnings, onClose, onConfirm }) {
  if (!show) return null;

  const hasErrors = errors.length > 0;

  return (
    <div className="modal fade show d-block" tabIndex="-1" style={{ backgroundColor: 'rgba(0, 0, 0, 0.5)' }}>
      <div className="modal-dialog modal-dialog-centered">
        <div className="modal-content">
          <div className="modal-header bg-warning py-1">
            <h6 className="modal-title text-dark m-0">CAMPOS PENDENTES</h6>
            <button type="button" className="btn-close btn-close-dark shadow-sm p-2" onClick={onClose}></button>
          </div>
          <div className="modal-body">
            {hasErrors && (
              <>
                <p className="fw-bold text-danger mb-2">
                  <i className="bi bi-x-circle-fill me-1"></i>Campos obrigatórios:
                </p>
                <ul className="mb-3">
                  {errors.map((e, i) => (
                    <li key={i} className="text-danger">{e}</li>
                  ))}
                </ul>
              </>
            )}
            {warnings.length > 0 && (
              <>
                <p className="fw-bold text-warning mb-2">
                  <i className="bi bi-exclamation-triangle-fill me-1"></i>Campos recomendados:
                </p>
                <ul className={hasErrors ? 'mb-3' : 'mb-0'}>
                  {warnings.map((w, i) => (
                    <li key={i} className="text-warning">{w}</li>
                  ))}
                </ul>
              </>
            )}
            {hasErrors && (
              <p className="text-muted small mt-3 mb-0">
                Preencha os campos obrigatórios antes de salvar.
              </p>
            )}
          </div>
          <div className="modal-footer">
            {hasErrors ? (
              <button type="button" className="btn btn-secondary btn-sm" onClick={onClose}>
                Fechar
              </button>
            ) : (
              <>
                <button type="button" className="btn btn-secondary btn-sm" onClick={onClose}>
                  Cancelar
                </button>
                <button type="button" className="btn btn-warning btn-sm" onClick={onConfirm}>
                  <i className="bi bi-check-circle me-1"></i>Salvar mesmo assim
                </button>
              </>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}

export default SaveValidationModal;
